import { Component, inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ZohoBooksService } from '../../../services/zoho-books-service/zoho-books-service.service';
import { AuthenticationFeatureService } from '../../../features/authentication-feature/authentication-feature.service';
import { RoutesConstants } from '../../../constants/routes.constants';

@Component({
  selector: 'app-zoho-callback',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  template: `
    <div class="flex flex-col justify-center items-center h-screen gap-4">
      @if (errorMessage) {
        <p class="text-red-600 text-lg">{{ errorMessage }}</p>
      } @else {
        <mat-spinner></mat-spinner>
        <p class="text-gray-600">Connecting your Zoho account…</p>
      }
    </div>
  `,
})
export class ZohoCallbackComponent implements OnInit {
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _zohoBooksService = inject(ZohoBooksService);
  private _authFeature = inject(AuthenticationFeatureService);

  errorMessage = '';

  ngOnInit() {
    const code = this._route.snapshot.queryParamMap.get('code');
    if (!code) {
      this.errorMessage = 'No authorization code received from Zoho.';
      return;
    }

    const account = this._authFeature.getInstance().getActiveAccount();
    const userEmail = account?.username;
    if (!userEmail) {
      this.errorMessage = 'Could not determine logged-in user. Please sign in first.';
      return;
    }

    this._zohoBooksService.exchangeCode(code, userEmail).subscribe({
      next: () => this._router.navigate([RoutesConstants.ZOHO_BOOKS_URL]),
      error: (err) => {
        this.errorMessage = `Failed to connect Zoho account: ${err?.error?.error ?? err?.message ?? 'Unknown error'}`;
      },
    });
  }
}
